export default `
max-width:1200px;margin:0 auto;padding:0 36px;
.my-column{width:33.33%;@media(max-width:900px){width:50%}@media(max-width:600px){width:100%;}padding:20px;background-color:#fbfbfb;border:1px solid #e6e6e6;}
.my-column-center{border-left:none;border-right:none;}
.my-row{display:flex;align-items:stretch;flex-wrap:wrap;justify-content:center;}
.my-heading2{text-align:center;margin-bottom:15px;}
.my-inner-div{max-width:300px;margin:0 auto;display:flex;height:100%;flex-wrap:wrap;}
.my-inner-p{font-size:16px;}
`